(ns client-portal.client.oasys.sessions.drawer.views
  (:require [clojure.string :as s]
            [client-portal.client.layout :as l]
            [client-portal.client.oasys.sessions.data :as oasys.sessions.d]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.sessions.drawer.views :as vi.drawer]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as time]
            [shared.core.util :as util]))

(defn ->detail [selected]
  (if selected
    @(re/subscribe [:oasys/conversation- selected])
    :loading))

(defn ms->display [ms]
  (some-> ms (/ 1000) (js/Math.round) (time/seconds->format)))

(defn resolution-icon [{:keys [resolution-status]}]
  (when resolution-status
    (let [{:keys [icon-type color]} (oasys.sessions.d/resolution-style resolution-status)]
      [alc/tooltip {:tooltip-content (util/->capitalize-words resolution-status)
                    :target-content [:div {:style {:display :flex
                                                   :align-items :center
                                                   :justify-content :center
                                                   :padding 2
                                                   :height 16}}
                                     [c/material-icon {:icon-type icon-type
                                                       :style {:color color
                                                               :font-size 16}}]]
                    :style {:height 16}}])))

(defn resolution-label [{:keys [resolution-status]}]
  (when resolution-status
    (let [label (util/->capitalize-words resolution-status)]
      [:div {:title label
             :style {:color (style/alc-color "Text/primary")
                     :font-size 12
                     :padding-left 4
                     :text-overflow :ellipsis
                     :overflow :hidden
                     :white-space :nowrap}}
       label])))

(defn header []
  (let [copied-link?* (re/ratom false)
        concept-id- (re/subscribe [:concepts/current-concept-id-])
        selected- (re/subscribe [:oasys/selected-session-])]
    (fn []
      [:div {:style {:background-color (style/alc-color "Background/secondary")
                     :flex "0 0 auto"
                     :display :flex
                     :gap 8
                     :padding "12px 16px"
                     :position :sticky
                     :top 0
                     :min-height 58
                     :box-sizing :border-box
                     :z-index (inc (style/z :medium))}}
       [:span {:style {:color (style/alc-color "Text/primary_header")
                       :display :flex
                       :align-items :center
                       :font-size 20
                       :font-weight 400
                       :line-height 1.4}}
        "Session Detail"]
       [c/spacer]
       ^{:key (str "share-" @copied-link?*)}
       [alc/tooltip
        {:tooltip-content (if @copied-link?* "Copied" "Copy Session Link")
         :target-content [alc/up-ghost-button {:icon-type (if @copied-link?* :CheckCircleIcon :CopyIcon)
                                               :on-click #(do
                                                            (re/dispatch [:core/copy-to-clipboard
                                                                          (oasys.sessions.d/sharable-session-url @concept-id- @selected-)
                                                                          {:notify? false}])
                                                            (reset! copied-link?* true)
                                                            (util/wait 1500 (fn [] (reset! copied-link?* false))))}]}]
       [alc/up-button {:icon-type :CrossIcon
                       :rounded? true
                       :on-click #(re/dispatch [:oasys/toggle-session-panel {:open? false}])}]])))

(defn value-pill
  "A value, after its label when it has one, on one line — a long value is cut short and
   read in full on hover. Not a tag pill: those re-format their text, which would mangle
   a value matched exactly."
  [{:keys [label value color]}]
  [:div {:title (str (when label (str label ": ")) value)
         :style {:background-color (util/hex->rgba color 0.3)
                 :border-radius 3
                 :color (style/alc-color "Text/primary")
                 :font-size 12
                 :line-height 1.5
                 :max-width "100%"
                 :overflow :hidden
                 :padding "0px 6px"
                 :text-overflow :ellipsis
                 :white-space :nowrap}}
   (when label
     (str label ": "))
   [:span {:style {:font-weight (if label style/font-semi-bold-weight style/font-regular-weight)}}
    value]])

(defn metric-card [{:keys [label value color]}]
  [:div {:style {:background-color (style/alc-color "Background/primary")
                 :border-radius 8
                 :display :flex
                 :flex-direction :column
                 :align-items :center
                 :flex 1
                 :padding 10
                 :gap 2
                 :height 66}}
   [:span {:style {:color (style/alc-color "Text/secondary")
                   :font-size 12
                   :line-height 1.33}}
    label]
   [:span {:style (cond-> {:font-size 18
                           :line-height 1.56
                           :color color}
                          (nil? value)
                          (assoc :opacity 0.6))}
    (or value "-")]])

(defn overview []
  (let [copied-convo-id?* (re/ratom false)
        selected- (re/subscribe [:oasys/selected-session-])
        sessions- (re/subscribe [:oasys/sessions-flattened-])
        next-page-loading?- (re/subscribe [:oasys/sessions-next-page-loading?-])
        admin?- (re/subscribe [:account/admin-role?-])]
    (fn []
      (let [selected @selected-
            idx (:convo-idx selected)
            detail (->detail selected)
            loaded (util/when-not-loading detail)
            loading? (util/loading? detail)
            escalated (:escalated loaded)
            nav-placeholder [:div {:style {:flex "0 0 36px"}}]]
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :display :flex
                       :flex-direction :column
                       :align-items :center
                       :gap 4
                       :padding "12px 0 0"}}
         (when @admin?-
           ^{:key (str "convo-id-" @copied-convo-id?*)}
           [alc/tooltip
            {:tooltip-content (if @copied-convo-id?* "Copied" "Copy Session ID")
             :target-content [c/interactive
                              :div {:on-click #(do
                                                 (re/dispatch [:core/copy-to-clipboard
                                                               (:conversation-id selected)
                                                               {:notify? false}])
                                                 (reset! copied-convo-id?* true)
                                                 (util/wait 1500 (fn [] (reset! copied-convo-id?* false))))}
                              [:div {:style (cond-> {:color (style/alc-color "Text/secondary")
                                                     :display :flex
                                                     :align-items :center
                                                     :justify-content :center
                                                     :gap 9}
                                                    (not @copied-convo-id?*)
                                                    (assoc :cursor :pointer))}
                               [:span {:style {:color :inherit
                                               :font-size 14
                                               :line-height 1.43}}
                                (:conversation-id selected)]
                               [c/material-icon {:icon-type (if @copied-convo-id?* :check-circle :content-copy)
                                                 :style {:color (style/alc-color "Icons/secondary")
                                                         :font-size 14}}]]]}])
         [:div {:style {:display :flex
                        :align-items :center
                        :justify-content :space-between
                        :padding "0 16px"
                        :width "100%"}}
          (if (and idx (pos? idx))
            [alc/up-ghost-button {:icon-type :ArrowLeftIcon
                                  :disabled @next-page-loading?-
                                  :on-click #(re/dispatch [:oasys/move-session :prev])}]
            nav-placeholder)
          [:span {:style {:color (style/alc-color "Text/primary_header")
                          :font-size 20
                          :line-height 1.4}}
           (or (:conversation-ts selected)
               (:conversation-ts loaded))]
          (if (and idx (or (< idx (dec (count @sessions-))) @next-page-loading?-))
            [alc/up-ghost-button {:icon-type :ArrowRightIcon
                                  :disabled @next-page-loading?-
                                  :on-click #(re/dispatch [:oasys/move-session :next])}]
            nav-placeholder)]
         [:div {:style {:display :flex
                        :gap 8
                        :padding "12px 16px"
                        :width "100%"}}
          (if loading?
            (into [:<>]
                  (repeat 3 [c/loader-rectangle {:height 66
                                                 :style {:border-radius 8
                                                         :flex 1}}]))
            [:<>
             [metric-card {:label "Duration"
                           :value (some-> loaded :duration (time/seconds->format))
                           :color (style/alc-color "Chart/tech_blue")}]
             [metric-card {:label "Messages"
                           :value (some-> loaded (not-empty) (oasys.sessions.d/message-count) (str))
                           :color (style/alc-color "Chart/orchid")}]
             [metric-card {:label "Escalated"
                           :value (when (some? escalated)
                                    (if escalated "Yes" "No"))
                           :color (style/alc-color "Chart/turquoise")}]])]]))))

(defn summary-section []
  (let [{:keys [channel resolution-status conversation-close-method escalation-queue escalation-reason
                satisfaction-score end-user-utterance-count amelia-utterance-count agent-utterance-count]}
        (util/when-not-loading (->detail @(re/subscribe [:oasys/selected-session-])))
        humanize #(if (util/not-blank-string? %) (util/->capitalize-words %) "-")]
    [vi.drawer/section-container {:default-expanded? true
                                  :title "Summary"}
     [vi.drawer/inner-section {:style {:display :flex
                                       :align-items :center
                                       :justify-content :center
                                       :gap 10}}
      [:span (or channel "N/A")]
      [c/material-icon {:icon-type :arrow-forward
                        :style {:color (style/alc-color "Icons/secondary")
                                :font-size 14}}]
      [:span (humanize resolution-status)]]
     [vi.drawer/inner-section {:style {:display :grid
                                       :grid-template-columns "1fr 1fr 1fr"
                                       :gap 12}}
      (for [[label value] [["Close Method" (humanize conversation-close-method)]
                           ["Escalation Queue" (or escalation-queue "-")]
                           ["Escalation Reason" (or escalation-reason "-")]
                           ["Customer Messages" (some-> end-user-utterance-count (str))]
                           ["AI Messages" (some-> amelia-utterance-count (str))]
                           ["Agent Messages" (some-> agent-utterance-count (str))]
                           ["Satisfaction" (some-> satisfaction-score (.toFixed 2))]]]
        ^{:key label}
        [vi.drawer/title-values-entry {:title label
                                       :values [value]}])]]))

(defn topics-section []
  (let [{:keys [topics messages]} (util/when-not-loading (->detail @(re/subscribe [:oasys/selected-session-])))
        message-id->start (into {} (map (juxt :message-id :start)) messages)]
    (when (not-empty topics)
      (into [vi.drawer/section-container {:default-expanded? true
                                          :title "Topics"}]
            (map (fn [{:keys [message-id topic-name resolution-status explanation]}]
                   (let [{:keys [icon-type color]} (oasys.sessions.d/resolution-style resolution-status)
                         start (message-id->start message-id)]
                     [vi.drawer/inner-section {}
                      [vi.drawer/sub-call-summary-row {:display-value topic-name
                                                       :call-time (ms->display start)
                                                       :start-ms start
                                                       :outcome-value (some-> resolution-status (util/->capitalize-words))
                                                       :outcome-color color
                                                       :outcome-icon-type icon-type}]
                      (when (not-empty explanation)
                        [:div {:style {:color (style/alc-color "Text/secondary")
                                       :padding-top 4}}
                         explanation])]))
                 topics)))))

(defn intents-section []
  (let [intents (-> (->detail @(re/subscribe [:oasys/selected-session-]))
                    (util/when-not-loading)
                    :intents)]
    (when (not-empty intents)
      [vi.drawer/section-container {:default-expanded? true
                                    :title "Intents"}
       [vi.drawer/inner-section {:style {:display :flex
                                         :flex-wrap :wrap
                                         :gap 8}}
        (for [intent intents]
          ^{:key intent}
          [value-pill {:value (tag/intent-name->display-name intent)
                       :color tag.d/blue-tag-color}])]])))

(defn json-block [_]
  (let [hover?* (re/ratom false)
        copied?* (re/ratom false)]
    (fn [{:keys [title json]}]
      [:div {:style {:margin-top 4
                     :position :relative}
             :on-mouse-enter #(reset! hover?* true)
             :on-mouse-leave #(reset! hover?* false)}
       [alc/json-viewer {:json json
                         :style {:max-height 180}}]
       (when @hover?*
         [:div {:style {:background-color (style/alc-color "Background/secondary")
                        :border-radius 6
                        :display :flex
                        :gap 2
                        :position :absolute
                        :right 6
                        :top 6}}
          [alc/up-ghost-button {:icon-type (if @copied?* :CheckCircleIcon :CopyIcon)
                                :tooltip-content (if @copied?* "Copied" "Copy")
                                :on-click #(do
                                             (re/dispatch [:core/copy-to-clipboard json {:notify? false}])
                                             (reset! copied?* true)
                                             (util/wait 1500 (fn [] (reset! copied?* false))))}]
          [alc/up-ghost-button {:icon-type :ZoomExpandIcon
                                :tooltip-content "Expand"
                                :on-click #(re/dispatch [:dialog/show [:dialog/json-dialog {:title title
                                                                                            :json json}]])}]])])))

(defn metrics-section
  "The session's custom metrics as name and values — plain ones two to a row, then the
   JSON ones full width. Codes spelled to the same readable name are one entry."
  []
  (let [entries (->> (-> (->detail @(re/subscribe [:oasys/selected-session-]))
                         (util/when-not-loading)
                         :metrics)
                     (group-by #(tag/metric-code->display-name (:metric-code %)))
                     (map (fn [[label metrics]]
                            (let [values (->> metrics (keep #(not-empty (:value %))) (distinct))
                                  jsons (map util/format-json-structure values)]
                              {:label label
                               :json? (boolean (some identity jsons))
                               :values (mapv (fn [v json]
                                               (if json
                                                 [json-block {:title label
                                                              :json json}]
                                                 v))
                                             values
                                             jsons)})))
                     (sort-by (juxt :json? :label)))]
    (when (not-empty entries)
      [vi.drawer/section-container {:default-expanded? true
                                    :title "Metrics"}
       [vi.drawer/inner-section {:style {:display :grid
                                         :grid-template-columns "repeat(2, minmax(0, 1fr))"
                                         :gap 12
                                         :overflow-wrap :anywhere}}
        (for [{:keys [label json? values]} entries]
          ^{:key label}
          [:div {:style (when json?
                          {:grid-column "1 / -1"})}
           [vi.drawer/title-values-entry {:title label
                                          :values (or (not-empty values) [nil])}]])]])))

(defn ->speaker [user-type]
  (case user-type
    "END_USER" "user"
    "AMELIA" "agent-ai"
    "AGENT" "agent-human"
    "agent"))

(defn transcript-section []
  (let [selected @(re/subscribe [:oasys/selected-session-])
        {:keys [messages topics]} (util/when-not-loading (->detail selected))
        search-val @(re/subscribe [:form/val- oasys.sessions.d/search-transcript-path :value])
        message-id->topics (group-by :message-id topics)
        utterances (mapv (fn [{:keys [message-id user-type message-text start]}]
                           {:speaker (->speaker user-type)
                            :transcript message-text
                            :start start
                            :end start
                            :tags (mapv (fn [{:keys [topic-name resolution-status explanation]}]
                                          {:name "topic"
                                           :value topic-name
                                           :hide-name? true
                                           :description explanation
                                           :icon-type (:icon-type (oasys.sessions.d/resolution-style resolution-status))})
                                        (message-id->topics message-id))})
                         messages)
        start->sentiment (->> messages
                              (filter #(util/not-blank-string? (:sentiment %)))
                              (map (fn [{:keys [start sentiment]}]
                                     [start {:value (s/lower-case sentiment)
                                             :description (util/->capitalize-words sentiment)}]))
                              (into {}))]
    [vi.drawer/section-container {:default-expanded? true
                                  :title "Transcript"}
     [:div {:style {:background-color (style/alc-color "Background/secondary")
                    :border-bottom (str "1px solid " (style/alc-color "Border/divider"))
                    :padding 16
                    :position :sticky
                    :top 58
                    :z-index (style/z :medium)}}
      [alc/up-input {:placeholder "Search Transcript"
                     :form-path oasys.sessions.d/search-transcript-path
                     :form-name :value}]]
     (if (empty? utterances)
       [vi.drawer/no-message-block {:message "No transcript for this session"}]
       ^{:key (:conversation-id selected)}
       [vi.drawer/utterances-transcript-list {:utterances utterances
                                              :start->utterance-sentiment start->sentiment
                                              :search-val search-val}])]))

(defmethod l/panel-right-view
  oasys.sessions.d/panel-key [_]
  (let [selected @(re/subscribe [:oasys/selected-session-])
        admin? @(re/subscribe [:account/admin-role?-])
        detail (->detail selected)
        loading? (util/loading? detail)]
    [:div {:id :session-drawer-scroll-container
           :style (cond-> {:overflow :auto}
                          loading?
                          (assoc :display :flex
                                 :flex-direction :column))}
     [header]
     [overview]
     (cond
       loading?
       [alc/up-loader-with-label {:label "Loading Session..."
                                  :style {:flex 1
                                          :height :auto
                                          :min-height :auto}}]

       (empty? detail)
       [vi.drawer/no-message-block {:message (str "No Session Found For \"" (:conversation-id selected) "\"")}]

       :else
       [:div
        [summary-section]
        [topics-section]
        [intents-section]
        (when admin?
          [metrics-section])
        [transcript-section]])]))
